import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../shared/base-service/base-api.service';

@Injectable()
export class CartService extends BaseApiService {
    // Gets the cart items the current users cart
    public getCartItems() {
        return this.get('Finance/BusinessTransactionCart');
    }

    public getCartItemCount() {
        return this.get('Finance/BusinessTransactionCart/Items');
    }

    // Clears all items from the cart
    public clearCart() {
        return this.post('Finance/BusinessTransactionCart/Items/Clear', null);
    }

    // Removes a specific item from the cart
    public removeCartItem(businessTransactionNumber: number) {
        return this.delete(`Finance/BusinessTransactionCart/Items/${businessTransactionNumber}`);
    }

    // Adds a business transaction as an item to the cart
    public addCartItem = (businessTransactionNumber: number) => this.post(`Finance/BusinessTransactionCart/Items/${businessTransactionNumber}`, null);

    // Fetch current cart business transactions by transaction id
    public getCartBusinessTransactionsByTransactionId = (businessTransactionId: number): Observable<any> => this.get('Finance/BusinessTransactionCart/' + businessTransactionId + '/CartBusinessTransactionsByTransactionId');
}
